// extracted by mini-css-extract-plugin
export var brandLockup = "_bs-5";
export var brandLogo = "_bs-6";
export var bullet = "_bs-1i";
export var bulletText = "_bs-1h";
export var bullets = "_bs-1c";
export var callout = "_bs-12";
export var calloutBody = "_bs-14";
export var calloutLabel = "_bs-13";
export var checkIcon = "_bs-1e";
export var checkList = "_bs-1b";
export var checkSvg = "_bs-1f";
export var checkText = "_bs-1g";
export var choiceCard = "_bs-x";
export var choiceDescription = "_bs-10";
export var choiceIcon = "_bs-11";
export var choiceText = "_bs-y";
export var choiceTitle = "_bs-z";
export var closeButton = "_bs-d";
export var codeText = "_bs-28";
export var compactPage = "_bs-f";
export var content = "_bs-9";
export var contentColumn = "_bs-3";
export var coverageCard = "_bs-o";
export var coverageDescription = "_bs-24";
export var coverageTitle = "_bs-23";
export var eyebrow = "_bs-i";
export var fieldCard = "_bs-m";
export var fieldDescription = "_bs-r";
export var fieldError = "_bs-s";
export var fieldHeader = "_bs-p";
export var fieldTitle = "_bs-q";
export var finalNote = "_bs-29";
export var footer = "_bs-a";
export var fulfillmentBody = "_bs-1u";
export var fulfillmentBodyText = "_bs-1v";
export var fulfillmentRow = "_bs-1r";
export var fulfillmentRows = "_bs-1q";
export var fulfillmentTitle = "_bs-1t";
export var header = "_bs-4";
export var heading = "_bs-h";
export var helperText = "_bs-1k";
export var indented = "_bs-1x";
export var inlineLink = "_bs-26";
export var inlineTitle = "_bs-2a";
export var intro = "_bs-k";
export var linkPreview = "_bs-1z";
export var listItem = "_bs-1d";
export var main = "_bs-1";
export var marketingImage = "_bs-c";
export var marketingPanel = "_bs-b";
export var modal = "_bs-0";
export var noteBody = "_bs-v";
export var noteBodyText = "_bs-w";
export var noteCard = "_bs-n";
export var noteIcon = "_bs-t";
export var noteTitle = "_bs-u";
export var numberBadge = "_bs-2e";
export var numberedStep = "_bs-2c";
export var numberedStepBody = "_bs-2f";
export var numberedStepCta = "_bs-2d";
export var numberedStepDescription = "_bs-2h";
export var numberedStepTitle = "_bs-2g";
export var numberedSteps = "_bs-2b";
export var page = "_bs-e";
export var playCircle = "_bs-18";
export var playIcon = "_bs-19";
export var policyBody = "_bs-21";
export var policyHeader = "_bs-20";
export var policyPreview = "_bs-1y";
export var policyTitle = "_bs-22";
export var progressFill = "_bs-8";
export var progressTrack = "_bs-7";
export var pseudoLink = "_bs-25";
export var pseudoLinkIcon = "_bs-27";
export var rowHeader = "_bs-1s";
export var section = "_bs-g";
export var shell = "_bs-2";
export var statusIconSuccess = "_bs-1m";
export var statusIconSvg = "_bs-1o";
export var statusIconWarning = "_bs-1n";
export var statusRow = "_bs-1l";
export var statusText = "_bs-1p";
export var stepTitle = "_bs-j";
export var strongText = "_bs-1w";
export var subHeading = "_bs-l";
export var videoEmbed = "_bs-16";
export var videoIframe = "_bs-17";
export var videoLabel = "_bs-1a";
export var videoPlaceholder = "_bs-15";
export var warningIcon = "_bs-1j";